/**
 * The workgroup of a device
 */
export enum DeviceWorkgroup {
  /**
   * A device that is used for digital inclusion
   */
  DigitalInclusion = 'digital-inclusion',

  /**
   * A device that is used for quick access
   */
  QuickAccess = 'quick-access',
}
